<template>
    <div>
        <hts-drawer
            v-model="visible"
            :submit="handleSubmit"
            :title="$t('labels.editVehiclePlugin')"
            :rules="rulesPluginRemooc"
            @close="closeOverSide">
            <div
                v-loading="loading"
                class="grid gap-4 p-5">
                <hts-form-select
                    v-model="dataFormEditPlugin.type"
                    :label="$t('labels.vehicleModule.pluginType')"
                    required
                    :items="listPluginType"
                    key-id="key"
                    key-label="name"
                    :color="props.color"
                    name="type"
                    prop="type" />
                <hts-select-remooc
                    v-if="dataFormEditPlugin.type === PluginType.MOOC"
                    v-model="dataFormEditPlugin.pluginData"
                    v-model:name="dataFormEditPlugin.name"
                    :api="$urlPartner.vehicle.remooc.find"
                    :label="$t('labels.mooc')"
                    required
                    prop="pluginData" />
                <hts-form-input
                    v-else
                    v-model="dataFormEditPlugin.name"
                    :label="$t('labels.vehicleModule.pluginName')"
                    required
                    :color="props.color"
                    name="name"
                    prop="name" />
                <hts-form-select
                    v-model="dataFormEditPlugin.status"
                    :label="$t('labels.status')"
                    :items="listStatus"
                    key-id="key"
                    key-label="value"
                    :color="props.color"
                    name="status"
                    prop="status" />
                <hts-form-input
                    v-model="dataFormEditPlugin.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
            </div>
        </hts-drawer>
    </div>
</template>
<script setup lang="ts">
import { PluginType, ContainerTypes } from '../imports/form'
import SelectRemooc from '../autocomplete/select-remooc.vue'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  }
})

const initPlugin = {
  pluginData: '',
  name: '',
  type: '',
  status: '',
  description: ''
}
const listPluginType = [
  {
    key: PluginType.MOOC,
    name: $t('labels.supplyList.mooc')
  }
  // {
  //   key: PluginType.OIL,
  //   name: $t('labels.supplyList.oil')
  // },
  // {
  //   key: PluginType.WHEEL,
  //   name: $t('labels.supplyList.wheel')
  // },
  // {
  //   key: PluginType.GENERATOR,
  //   name: $t('labels.supplyList.generator')
  // },
  // {
  //   key: PluginType.CONTAINER,
  //   name: $t('labels.supplyList.container')
  // },
  // {
  //   key: PluginType.CHARGE,
  //   name: $t('labels.supplyList.charge')
  // }
]

const visible = ref(false)

const open = (id: string) => {
  pluginId.value = id
  visible.value = true
  _init()
}
defineExpose({
  open
})
const closeOverSide = () => {
  visible.value = false
}

const listStatus = [
  {
    key: -1,
    value: $t('labels.vehicleModule.inactive')
  },
  {
    key: 1,
    value: $t('labels.vehicleModule.active')
  }
]
const emits = defineEmits(['refreshTables'])
const dataFormEditPlugin = reactive({ ...initPlugin })
const pluginId = ref('')
const loading = ref(false)
const _init = () => {
  const api = $urlPartner.vehicle.plugin.getDetail
  loading.value = true
  $api(api, { uriParams: { ID: pluginId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataFormEditPlugin, { ...resData.data })
        loading.value = false
      }
    })
    .catch(() => {
      loading.value = false
    })
}

const handleSubmit = () => {
  const api = $urlPartner.vehicle.plugin.editPlugin

  $api(api, { uriParams: { id: pluginId.value }, body: { ...dataFormEditPlugin } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        emits('refreshTables')
        process.client && $toast().success(resData.data)
      }
      visible.value = false
    })
    .catch(() => {
      visible.value = false
    })
}

const defineRulesPluginRemooc = {
  type: 'required'
}
const rulesPluginRemooc = computed(() => {
  const result: { [key: string]: any } = defineRulesPluginRemooc
  if (dataFormEditPlugin.type) {
    result.pluginData = 'required'
  }
  return result
})
</script>
